import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer" style={{
      background: 'linear-gradient(170deg,rgba(232, 12, 129, 1) 0%, rgba(252, 176, 69, 1) 50%, rgba(242, 242, 242, 1) 100%)',
      color: 'white',
      padding: '2rem 0',
      marginTop: '3rem'
    }}>
      <div className="container">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '2rem' }}>
          <div style={{ flex: 1 }}>
            <h4 style={{ marginBottom: '1rem' }}>Quick Links</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <Link to="/" style={{ color: 'white', textDecoration: 'none' }}>Home</Link>
              <Link to="/products" style={{ color: 'white', textDecoration: 'none' }}>Products</Link>
              <Link to="/services" style={{ color: 'white', textDecoration: 'none' }}>Services</Link>
              <Link to="/about" style={{ color: 'white', textDecoration: 'none' }}>About Us</Link>
              <Link to="/contact" style={{ color: 'white', textDecoration: 'none' }}>Contact</Link>
            </div>
          </div>
          <div style={{ flex: 1 }}>
            <h4 style={{ marginBottom: '1rem' }}>Connect</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <a href="https://wa.me/6598592974" target="_blank" rel="noopener noreferrer" style={{ color: 'white', textDecoration: 'none' }}>
                📱 WhatsApp
              </a>
              <a href="https://www.facebook.com/people/Star-Tid-Bits/pfbid0DJVdpLfbH9edBWVmXpG9tqMd98T8AMQAF1oDVsggeZvahtYuvThsVq45w2fjkCC6l/?ref=waios.fb_links_xma_control" target="_blank" rel="noopener noreferrer" style={{ color: 'white', textDecoration: 'none' }}>
                📘 Facebook
              </a>
            </div>
          </div>
          <div style={{ flex: 1, textAlign: 'right' }}>
            <h3 style={{ marginBottom: '1rem' }}>Star Tidbits</h3>
            <p style={{ margin: '0.5rem 0' }}>
              No.1 Bukit Batok Crescent<br/>
              #04-13 Wcega Plaza<br/>
              Singapore 658064
            </p>
            <p style={{ margin: '1rem 0 0 0', fontSize: '0.875rem', opacity: 0.8 }}>
              © {new Date().getFullYear()} Star Tidbits. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;